import { AUTH_RESEND_MOBILE_VERIFICATION_INTERVAL, ROUTE_CREATE_ACCOUNT, ROUTE_HOMEPAGE, ROUTE_LANDING, ROUTE_LOGIN, ROUTE_MOBILE_NUMBER, ROUTE_POST_MOBILE_VERIFICATION, ROUTE_UPLOAD_FIRST_BILL } from '@1bill-app/constants';
import { AuthQuery } from '@1bill-app/services/auth/state/auth.query';
import { AuthService } from '@1bill-app/services/auth/state/auth.service';
import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavController, Platform } from '@ionic/angular';
import { NGXLogger } from 'ngx-logger';

import { Capacitor } from '@capacitor/core';
import { KeyboardResize, Keyboard } from '@capacitor/keyboard';
import { Device } from '@capacitor/device';
import ERROR_MSGS from './error-msgs';
import { StorageItemKeys, StorageService } from '@1bill-app/services/storage.service';
import { CodeInputComponent } from 'angular-code-input';
import { Observable, Subject, timer } from 'rxjs';
import { map, startWith, switchMapTo, takeWhile } from 'rxjs/operators';
@Component({
  selector: 'app-mobile-verification',
  templateUrl: './mobile-verification.page.html',
  styleUrls: ['./mobile-verification.page.scss'],
})
export class MobileVerificationPage implements OnInit {
  @ViewChild(CodeInputComponent) codeInput: CodeInputComponent;
  landingPage = ROUTE_LANDING;
  isVerifying: boolean;
  isVerified: boolean;
  isAlreadyVerified: boolean;
  isVerificationError: boolean;
  // serverValidationError:string;
  /* DOM Reference */
  @ViewChild('btnVerify') btnVerify: any;
  /* Native keyboard property */
  public keyboardHeight = 0;
  public isNative = Capacitor.isNativePlatform();
  public isKeyboardShow: boolean;
  public isAuthLoading$ = this.authQuery.isLoading$;
  /* Flag property */
  public showError = false;
  /* model property */
  public email: any;
  /* state property */
  public error$ = this.authQuery.selectError();
  /* others */
  public errorMsgs = ERROR_MSGS;
  password: any;
  code: string;
  showErrs = false;
  uncomfirmedMobile: string;

  readonly resend$ = new Subject<void>();

  readonly countdown$ = this.resend$.pipe(
    startWith(0),
    switchMapTo(countdownFrom(AUTH_RESEND_MOBILE_VERIFICATION_INTERVAL))
  );
  constructor(
    private navCtrl: NavController,
    private rotue: ActivatedRoute,
    private authService: AuthService,
    private logger: NGXLogger,
    private zone: NgZone,
    private route: ActivatedRoute,
    private authQuery: AuthQuery,
    private storageService: StorageService,
    public platform: Platform,
  ) { }
  ngOnInit() {
    this.keyboardListener();
    this.email = this.authQuery.getValue().credentials?.email;
    this.logger.debug(this.route.snapshot.params);
    // this.password = this.route.snapshot.data.password;
    //   if (!this.email) {
    //     this.navCtrl.navigateBack([ROUTE_CREATE_ACCOUNT]);
    //   }
    this.authQuery.select('unconfirmedMobile').subscribe(res => {
      if (res) {
        this.uncomfirmedMobile = res;
      } else {
        this.logger.log('Routing back to mobile number page.');
        this.navCtrl.navigateBack([ROUTE_MOBILE_NUMBER]);
      }
    })

  }
  ionViewWillEnter() {
    if (Capacitor.isNativePlatform()) {
      Keyboard.setResizeMode({ mode: KeyboardResize.None });
    }
    // setTimeout(() => this.emailInput.setFocus(), 400);
  }
  ionViewDidEnter() {
    this.codeInput.focusOnField(0);
  }
  ionViewWillLeave() {
    if (Capacitor.isNativePlatform()) {
      Keyboard.setResizeMode({ mode: KeyboardResize.Native });
    }
  }

  async onClickSkip() {
    if (await this.storageService.getItem(StorageItemKeys.FIRST_BILL_UPLOADED)) {
      this.navCtrl.navigateForward([ROUTE_UPLOAD_FIRST_BILL]);
    } else {
      this.navCtrl.navigateForward([ROUTE_HOMEPAGE]);
    }
  }

  get codeUiValid() {
    return this.code && this.code.length == 6;
  }
  get codeClass() {
    return this.showError ? 'error' : '';
  }
  verifyCode() {

    this.logger.debug('Verification code: ', this.code);

    if (!this.codeUiValid) {
      this.showError = true;
      return;
    }
    this.showError = false;
    this.authService.verifyMobileNumber(this.code, this.uncomfirmedMobile).subscribe({
      next: (result) => {
        this.logger.debug(result);
        this.navCtrl.navigateForward(ROUTE_POST_MOBILE_VERIFICATION);
      },
      error: (err) => {
        this.logger.error('this.authService.verifyMobileNumber',err);
        this.showError = true;
        if (
          err &&
          err.code === 'NotAuthorizedException' &&
          err.message.includes('Current status is CONFIRMED')
        ) {
          setTimeout(() => {
            // TODO:
            this.navCtrl.navigateForward([ROUTE_LOGIN]);
            // this.serverValidationError = 'That code didn’t work, please try again';
          }, 400);
        }
      },
    });
  }
  async keyboardListener() {
    const appInfo = await Device.getInfo();
    if (Capacitor.isNativePlatform()) {
      Keyboard.addListener('keyboardWillShow', (e) => {
        this.logger.debug('keyboardWillShow:', e);
        this.zone.run(() => {
          if (appInfo.platform === 'ios') {
            this.keyboardHeight = e.keyboardHeight;
          }
          this.isKeyboardShow = true;
        });
      });
      Keyboard.addListener('keyboardWillHide', () => {
        this.logger.debug('keyboardWillHide');
        this.zone.run(() => {
          this.keyboardHeight = 0;
          this.isKeyboardShow = false;
        });
      });
    }
  }

  onCodeCompleted(code: string) {
    this.logger.debug('onCodeCompleted:', code);
    this.code = code;
  }

  onCodeChanged(event: { code: string }) {
    this.logger.debug('onCodeChanged:', event);
  }

  async processVerification() {
    this.isVerifying = true;
    try {
      const code = this.rotue.snapshot.queryParamMap.get('verification_code');
      const encodedData = this.rotue.snapshot.queryParamMap.get('verification_data');
      if (!code || !encodedData) {
        this.isVerificationError = true;
        this.isVerifying = false;
        return;
      }
      const decodedData = JSON.parse(atob(encodedData));
      const { userName } = decodedData;
      // wait 400ms
      await new Promise<void>((resolve) => setTimeout(() => resolve(), 400));
      // confirm signup
      await this.authService.confirmSignUp(userName, code, true).toPromise();
      this.isVerified = true;
    } catch (err) {
      if (err.message && err.message.includes('Current status is CONFIRMED')) {
        this.isAlreadyVerified = true;
      } else {
        this.isVerificationError = true;
      }
      this.logger.error(err);
    }
    this.isVerifying = false;
    return;
  }

  resendVerification() {
    this.authService.resendMobileVerificationCode().subscribe(d => {
      this.resend$.next();
    });
  }
}

function countdownFrom(start: number): Observable<number> {
  return timer(0, 1000).pipe(
    map(index => start - index),
    takeWhile<number>(Boolean, true)
  );
}